import React from 'react';
import { connect } from 'react-redux';
import StoredLayout from 'layouts/StoredLayout';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CertificationActiveCertAnalyticsDetailsList from 'pages/analytics/components/certification/CertificationActiveCertAnalyticsDetailsList';
class CertificationActiveCertAnalyticsDetailsPopup extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.show = this.show.bind(this);

        this.state = {
            modal: false,
        };
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
        });
    }
    componentDidMount() {
        // if (this.props.ref) {
        //     this.props.ref(this.show);
        // }
    }

    show(title) {
        this.setState({
            title,
            modal: true,
        });
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>{this.state.title}</ModalHeader>
                <ModalBody style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <CertificationActiveCertAnalyticsDetailsList />
                </ModalBody>
                <ModalFooter>
                    <Button color="info" onClick={this.toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
export default CertificationActiveCertAnalyticsDetailsPopup;
